import { createContext, useContext } from 'react'

export type GroupPosition = 'start' | 'middle' | 'end' | 'standalone'

type InputGroupContextValue = {
  position: GroupPosition
}

export const InputGroupContext = createContext<InputGroupContextValue | null>(null)

/**
 * Hook to get the current input group position.
 * Returns 'standalone' if not inside an InputGroup.
 */
export function useInputGroupPosition(): GroupPosition {
  const context = useContext(InputGroupContext)
  return context?.position ?? 'standalone'
}
